/**
 * Frontend logging service. Single channel for app logs and errors.
 * Use for catch blocks and structured logging; avoids ad-hoc console.error/warn.
 */

const PREFIX = '[Runcards]';

export const loggingService = {
  error(message, metadata = {}) {
    if (typeof message === 'string') {
      console.error(`${PREFIX} ${message}`, metadata?.error ?? metadata);
    } else {
      console.error(`${PREFIX} Error`, message, metadata);
    }
  },

  warn(message, metadata = {}) {
    console.warn(`${PREFIX} ${message}`, metadata?.error ?? metadata);
  },

  info(message, metadata = {}) {
    if (process.env.NODE_ENV === 'development') {
      console.info(`${PREFIX} ${message}`, metadata);
    }
  },
};

export default loggingService;
